
import { useLanguage } from '@/context/LanguageContext';

const StrategiesHero = () => {
  const { t } = useLanguage();

  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      {/* Background image — adjust opacity (0 to 1) and blend mode to control visibility */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/background_images/strategies_background.jpg')",
          opacity: 0.2,           // ← tweak this (0–1) to control image visibility
          mixBlendMode: 'normal', // ← try: 'normal', 'overlay', 'soft-light', 'luminosity', 'screen'
        }}
      />
      {/* Gradient overlays for depth and edge fading */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-transparent to-gray-900" style={{ opacity: 0.7 }} />
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900 via-transparent to-gray-900" style={{ opacity: 0.5 }} />

      {/* Ambient glow accents */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-600/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-indigo-600/10 rounded-full blur-3xl" />

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        {/* TheClub logo */}
        <div className="flex justify-center mb-8">
          <img
            src="/logo_1_inverted_no_background.png"
            alt="The Club"
            className="h-20 md:h-24 object-contain"
          />
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight">
          {t('strategies.pageTitle')}
        </h1>

        <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
          {t('strategies.heroSubtitle')}
        </p>

        {/* Decorative line */}
        <div className="mt-10 flex justify-center">
          <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-purple-500 to-transparent" />
        </div>
      </div>
    </section>
  );
};

export default StrategiesHero;
